import { isObject, isString } from 'src/helpers';

export function extractErrorMessage(error: unknown): string {
  return isObject(error) && 'message' in error && isString(error.message) ? error.message : String(error);
}
